<template>
  <section class="section-guest">
    <div class="section-inner">
      <div class="section-title">
        <span class="dot-left">
          <i></i>
          <i></i>
          <i></i>
        </span>
        {{ $t("content.guest.title") }}
        <span class="dot-right">
          <i></i>
          <i></i>
          <i></i>
        </span>
      </div>

      <div class="content-outer">
        <!-- 主席区块 -->
        <div class="chair-block" v-if="chairList.length > 0">
          <h3 class="block-title">{{ $t("content.guest.chair") }}</h3>
          <div class="guest-wrap">
            <div class="guest-item" v-for="(item, idx) in chairList" :key="'chair-' + idx">
              <div class="guest-avatar">
                <img
                  :src="item.avatarurl || require('@/assets/images/guest.png')"
                  alt="嘉宾头像"
                />
              </div>
              <div class="guest-text">
                <h4 class="guest-name">{{ item.realname }}</h4>
                <p class="guest-job" v-if="item.company">{{ item.company }}</p>
                <p class="guest-job" v-if="item.title">{{ item.title }}</p>
              </div>
            </div>
          </div>
        </div>

        <!-- 荣誉主席区块 -->
        <div class="honor-chair-block" v-if="honorChairList.length > 0">
          <h3 class="block-title">{{ $t("content.guest.honorChair") }}</h3>
          <div class="guest-wrap">
            <div class="guest-item" v-for="(item, idx) in honorChairList" :key="'honor-' + idx">
              <div class="guest-avatar">
                <img
                  :src="item.avatarurl || require('@/assets/images/guest.png')"
                  alt="嘉宾头像"
                />
              </div>
              <div class="guest-text">
                <h4 class="guest-name">{{ item.realname }}</h4>
                <p class="guest-job" v-if="item.company">{{ item.company }}</p>
                <p class="guest-job" v-if="item.title">{{ item.title }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { getEventGuests } from '@/api/event';
import config from '@/config';

export default {
  name: "SectionGuest",
  data() {
    return {
      guestList: [],
      honorChairList: [],
      chairList: []
    }
  },
  async mounted() {
    await this.fetchGuestData();
  },
  methods: {
    async fetchGuestData() {
      try {
        const res = await getEventGuests(config.EVENTID);
        console.log(res);
        if (res.code !== 200 || !res.data) return;

        const { list, guests } = res.data;
        const result = [];

        for (const row of list) {
          const guestInfo = guests[row.guestid];
          if (!guestInfo) continue;

          result.push({
            realname: guestInfo.realname || '',
            avatarurl: guestInfo.avatarurl || '',
            company: guestInfo.company || '',
            title: guestInfo.title || '',
            tags: Array.isArray(guestInfo.tags) ? guestInfo.tags : []
          });
        }

        this.guestList = result;
        // 分组过滤
        this.honorChairList = result.filter(item => item.tags.includes('荣誉主席'));
        this.chairList = result.filter(item => item.tags.includes('主席'));

      } catch (err) {
        console.error('加载嘉宾数据失败', err);
      }
    }
  }
}
</script>

<style scoped>
.section-guest {
  padding: 40px 20px;
  width: 100%;
  display: flex;
  justify-content: center;
  /* 移除背景色，让父级背景图透出来 */
  background: transparent;
  position: relative;
  z-index: 1;
}

.section-inner {
  width: 100%;
  max-width: 1300px;
}

/* 标题样式 */
.section-title {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 14px;
  font-size: 24px;
  font-weight: 500;
  color: #0f3494;
  margin: 0 0 40px;
}
.dot-left,
.dot-right {
  display: flex;
  align-items: center;
  gap: 2px;
}
.dot-left i,
.dot-right i {
  background-color: #0f3494;
  border-radius: 2px;
}
.dot-left i:nth-child(1) { width: 5px; height: 5px; }
.dot-left i:nth-child(2) { width: 8px; height: 8px; }
.dot-left i:nth-child(3) { width: 12px; height: 12px; }
.dot-right i:nth-child(1) { width: 12px; height: 12px; }
.dot-right i:nth-child(2) { width: 8px; height: 8px; }
.dot-right i:nth-child(3) { width: 5px; height: 5px; }

.content-outer {
  width: 100%;
}

.block-title {
  font-size: 20px;
  color: #0f3494;
  font-weight: 400;
  margin: 0 0 20px 0;
  text-align: center;
}

.honor-chair-block {
  margin-bottom: 40px;
}
.chair-block {
  margin-bottom: 20px;
}

/* 嘉宾网格：flex 居中 */
.guest-wrap {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 40px 30px;
}

/* 单个嘉宾卡片 - 固定宽度170px */
.guest-item {
  text-align: center;
  width: 170px;
  flex-shrink: 0;
}

/* 圆角头像容器 - 宽高比3:4 */
.guest-avatar {
  width: 100%;
  aspect-ratio: 3 / 4;
  border-radius: 12px;
  overflow: hidden;
  margin-bottom: 16px;
  background: #e8f0ff;
}
.guest-avatar img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center top;
}

/* 嘉宾姓名 */
.guest-name {
  font-size: 22px;
  color: #0f3494;
  font-weight: 600;
  margin: 0 0 8px;
}
/* 职位描述 */
.guest-job {
  font-size: 14px;
  color: #333;
  line-height: 1.6;
  margin: 0;
}

/* 平板适配 */
@media screen and (max-width: 1200px) {
  .guest-item {
    width: 160px;
  }
  .guest-wrap {
    gap: 30px 20px;
  }
  .guest-name {
    font-size: 19px;
  }
}

/* 平板小屏 */
@media screen and (max-width: 992px) {
  .guest-item {
    width: 150px;
  }
  .guest-wrap {
    gap: 25px 16px;
  }
}

/* 移动端 */
@media screen and (max-width: 768px) {
  .section-guest {
    padding: 30px 16px 35px;
  }
  .section-title {
    font-size: 20px;
    gap: 10px;
    margin-bottom: 28px;
  }
  .dot-left i:nth-child(3),
  .dot-right i:nth-child(1) {
    width: 8px;
    height: 8px;
  }
  .dot-left i:nth-child(2),
  .dot-right i:nth-child(2) {
    width: 6px;
    height: 6px;
  }
  .dot-left i:nth-child(1),
  .dot-right i:nth-child(3) {
    width: 4px;
    height: 4px;
  }
  .guest-item {
    width: 140px;
  }
  .guest-wrap {
    gap: 24px 12px;
  }
  .guest-name {
    font-size: 17px;
  }
  .guest-job {
    font-size: 13px;
  }
  .block-title {
    font-size: 18px;
  }
}

/* 小屏手机 */
@media screen and (max-width: 480px) {
  .guest-item {
    width: 120px;
  }
  .guest-wrap {
    gap: 20px 10px;
  }
  .guest-name {
    font-size: 15px;
  }
  .guest-job {
    font-size: 12px;
  }
}
</style>